<template>
  <WizardBox title="New Stock Item">
      <template v-slot:tools>
        
      </template>
      <template v-slot:content>
        <FormGroup v-bind:form="stockForm">
          <FormWizard ref="stockWizard" :submitting="submitting" v-bind:tabList="tabList" @finished="handleSubmit">
            <template v-slot:content>
              
              <FormWizardStep index="1" v-bind:active="true">
                <FormRow label="Name"><FormInputText placeholder="Name" v-model="stock.name" field="name" /></FormRow>
                <FormRow label="Code"><FormInputText placeholder="Code" v-model="stock.code" field="code" /></FormRow>
                <FormRow label="Stock Type"><FormSelect placeholder="Code" v-model="stock.type" field="type" :options="stockTypeOptions" /></FormRow>
                <FormRow label="Stock Category">
                  <FormStockCategorySelect placeholder="Category" :stockType="stock.type" v-model="stock.stockCategoryId" field="stockCategoryId" />
                </FormRow>
                <FormRow label="Unit Of Measure" v-show="!stockTypeIsTemplate">
                  <FormSelect placeholder="Unit of measure" v-model="stock.uomType" field="uomType" :options="stockUOMTypeOptions" v-show="!stockTypeIsGlass" />
                  <div class="col-form-label" v-if="stockTypeIsGlass">{{getLookupName(stockUOMTypeOptions, stock.uomType)}}</div>
                </FormRow>
                <FormRow label="Notes"><FormInputTextArea placeholder="Notes" v-model="stock.note" field="note" /></FormRow>
              </FormWizardStep>

              <FormWizardStep index="2">
                <div v-show="stockTypeIsGlass">
                  <FormRow label="Glass Type"><FormSelect placeholder="Glass Type" v-model="stock.glassType" field="glassType" :options="glassTypeOptions" /></FormRow>
                  <FormRow label="Glass Thickness"><FormInputText placeholder="Glass Thickness" v-model="stock.thickness" field="thickness" addon="mm" /></FormRow>
                </div>

                <div v-show="stockTypeIsGeneral">
                  <FormRow label="Weight"><FormInputText placeholder="Weight" v-model="stock.weight" field="weight" addon="kg" /></FormRow>
                  <FormRow label="Thickness"><FormInputText placeholder="Thickness" v-model="stock.thickness" field="thickness" addon="mm" /></FormRow>
                </div>

                <FormHorizontalRule />
                <ContentTitle>Options</ContentTitle>
                <div class="row no-gutters">
                  <div class="col-4">
                    <FormRow label="Tracking Quantities" :labelColumnSize="6">
                      <FormCheckbox v-model="stock.isTrackingQuantity" field="isTrackingQuantity" />
                    </FormRow>
                    <FormRow label="Delivery Fee Type" v-show="stockTypeIsGeneral" :labelColumnSize="6">
                      <FormCheckbox v-model="stock.isDeliveryFeeType" field="isDeliveryFeeType" />
                    </FormRow>
                    <FormRow label="Hand Cut Glass" v-show="stockTypeIsGlass" :labelColumnSize="6">
                      <FormCheckbox v-model="stock.isHandCut" field="isHandCut" />
                    </FormRow>

                    <FormRow v-show="stockTypeIsGlass" label="Two Sided Glass Type" helpTip="Select if the stock has seperate smooth and rough facing sides" :labelColumnSize="6">
                      <FormSelect v-model="stock.faceLayerType" :options="StockFaceLayerTypeLookup" />
                    </FormRow>
                    <FormRow v-show="stockTypeIsGlass && stock.isStockUsingFaces" label="Default Side Up" helpTip="Select the default side up for order entry" :labelColumnSize="6">
                      <FormSelect v-model="stock.defaultFaceSideUp" :options="stockFaceUpOptions" field="defaultFaceSideUp" />
                    </FormRow>
                    <FormRow v-show="stockTypeIsGlass && stock.isStockUsingFaces" label="Cutting Side Up" helpTip="Select the side up for cutting" :labelColumnSize="6">
                      <FormSelect v-model="stock.cuttingFaceSideUp" :options="stockFaceUpOptions" field="cuttingFaceSideUp" />
                    </FormRow>
                    <FormRow v-show="stockTypeIsGlass" label="Has Grain Direction" helpTip="Select if the stock has a grain direction. Direction is set per glass size type in stock management" :labelColumnSize="6">
                      <FormCheckbox v-model="stock.isStockUsingGrain" field="isStockUsingGrain" />
                    </FormRow>
                    <FormRow v-show="stockTypeIsGeneral" label="Task Completable" helpTip="Select if the stock can be completed by the task system. Otherwise it will be automatically completed and invoiced on order completion" :labelColumnSize="6">
                      <FormCheckbox v-model="stock.isTaskCompletable" field="isTaskCompletable" />
                    </FormRow>
                  </div>
                  <div class="col-4">
                    <div v-show="stockTypeIsGlass">
                      <FormRow label="Display Material Type" helpTip="How the glass is displayed in the order editor" :labelColumnSize="6">
                        <FormSelect v-model="stock.stockMaterialType" field="stockMaterialType" :options="StockMaterialTypeLookup" />
                      </FormRow>
                      <FormRow label="Glass Colour" v-if="stock.stockMaterialType == StockMaterialTypes.colour" :labelColumnSize="6">
                        <FormColourTag v-model="stock.stockColour1" field="stockColour1" />
                      </FormRow>
                      <FormRow label="Gradient Primary Colour" v-if="stock.stockMaterialType == StockMaterialTypes.gradient" :labelColumnSize="6">
                        <FormColourTag v-model="stock.stockColour1" field="stockColour1" />
                      </FormRow>
                      <FormRow label="Gradient Secondary Colour" v-if="stock.stockMaterialType == StockMaterialTypes.gradient" :labelColumnSize="6">
                        <FormColourTag v-model="stock.stockColour2" field="stockColour2" />
                      </FormRow>
                      <FormRow label="Opacity" :labelColumnSize="6">
                        <FormInputText type="number" addon="%" v-model="stock.stockColourOpacity" field="stockColourOpacity" />
                      </FormRow>
                    </div>
                  </div>
                </div>
                
              </FormWizardStep>

              <FormWizardStep index="3">

                <!-- Glass Pricing -->
                <div v-show="stockTypeIsGlass">
                  <div class="row mb-2">
                    <div class="col-lg-12">
                      <h3>Glass Pricing</h3>
                    </div>
                  </div>
                  <SalesGlassPricingEditor 
                    :priceGroupList="stockPriceGroupList" 
                    :uomType="stock.uomType" 
                    @update="stockPriceGroupList = $event"
                    :editing="true" />
                </div>

                <!-- Glass Service Pricing -->
                <div v-show="stockTypeIsGlassService">
                  <div class="row mb-2">
                    <div class="col-lg-12">
                      <h3>Glass Service Pricing</h3>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-lg-12">
                      <SalesServicePricingEditor 
                        :priceGroupList="serviceSalesPriceList"
                        :uomType="stock.uomType"
                        @update="serviceSalesPriceList = $event"
                        :editing="true" />
                    </div>
                  </div>
                </div>

                <div v-show="stockTypeIsGeneral">
                  <SalesGeneralPricingEditor 
                    :priceList="generalSalesPriceList"
                    :uomType="stock.uomType"
                    @update="generalSalesPriceList = $event"
                    :editing="true" />
                </div>

                <div v-show="stockTypeIsTemplate || stockTypeIsAssembly">
                  No pricing available for this stock type
                </div>
              </FormWizardStep>

              <FormWizardStep index="4">
                <!-- Template / Assembly -->
                <div v-show="stockTypeIsTemplate || stockTypeIsAssembly">
                  <StockTemplateEditor :templateList="stock.templateList" @update="stock.templateList = $event" :editing="true" />
                </div>
                
              </FormWizardStep>

            </template>

          </FormWizard>
        </FormGroup>
      </template>
    </WizardBox>
</template>

<script>
import _ from 'lodash'
import form from '@/mixins/form'
import WizardBox from '@/components/wizardBox'
import FormStockCategorySelect from '@/modules/inventory/components/formStockCategorySelect'
import SalesGlassPricingEditor from '@/modules/pricing/components/salesGlassPricingEditor.vue'
import SalesServicePricingEditor from '@/modules/pricing/components/salesServicePricingEditor.vue'
import SalesGeneralPricingEditor from '@/modules/pricing/components/salesGeneralPricingEditor.vue'
import StockTemplateEditor from '@/modules/inventory/components/stockTemplateEditor.vue'

import { InventoryStockTypes, InventoryStockTypeLookup, UOMTypes, UOMTypeLookup, GlassTypes, GlassTypeLookup, StockMaterialTypes, StockMaterialTypeLookup, StockFaceTypes, StockFaceTypeLookup, StockFaceLayerTypes, StockFaceLayerTypeLookup } from '@/store/types'


export default {
  name: 'StockNew',
  mixins: [form],
  components: {
    WizardBox,
    FormStockCategorySelect,
    SalesGlassPricingEditor,
    SalesServicePricingEditor,
    SalesGeneralPricingEditor,
    StockTemplateEditor
  },
  props: {
    stockDefaults: Object
  },
  data() {
    var newStockData = {
      stockTypeOptions: InventoryStockTypeLookup,
      stockFaceUpOptions: StockFaceTypeLookup,
      StockFaceLayerTypeLookup: StockFaceLayerTypeLookup,
      glassTypeOptions: GlassTypeLookup.filter(type => type.value != GlassTypes.all),
      stockPriceGroupList: [],
      serviceSalesPriceList: [],
      generalSalesPriceList: [{
        name: 'Price',
        isActive: false,
        isPendingUpdate: false,
        price: 0,
        minChargePrice: 0,
       stockSalesPriceId: null
      }],
      stockForm: {},
      stock: {
        type: InventoryStockTypes.glass,
        uomType: UOMTypes.metresq,
        glassType: GlassTypes.annealed,
        templateList: [],
        isTrackingQuantity: true,
        isDeliveryFeeType: false,
        isHandCut: false,
        isStockUsingFaces: false,
        defaultFaceSideUp: StockFaceTypes.smooth,
        cuttingFaceSideUp: StockFaceTypes.smooth,
        isStockUsingGrain: false,
        isTaskCompletable: true,
        faceLayerType: StockFaceLayerTypes.none,
        stockMaterialType: StockMaterialTypes.colour,
        stockColour1: '#DCEEF6',
        stockColour2: '#808080',
        stockColourOpacity: 50,
      },
      display: {
        isSalesMatrixDisplayPrice: true
      },
      submitting: false
    }

    if(this.$props.stockDefaults) {
      newStockData.stock = _.merge(newStockData.stock, this.$props.stockDefaults)
    }

    return newStockData
  },
  watch: {
    'stock.type': function(newVal, oldVal) {
      if(newVal == InventoryStockTypes.glass)
        this.$data.stock.uomType = UOMTypes.metresq
    },
    'stock.faceLayerType': function() {
      this.stock.isStockUsingFaces = this.stock.faceLayerType != StockFaceLayerTypes.none
    }
  },
  created() {
    this.StockMaterialTypes = StockMaterialTypes
    this.StockMaterialTypeLookup = StockMaterialTypeLookup
  },
  mounted() {
    this.requestStockPriceGroupList()
    this.requestServicePriceGroupList()
  },
  computed: {
    stockTypeIsGlass() { return this.stock.type == InventoryStockTypes.glass },
    stockTypeIsGlassService() { return this.stock.type == InventoryStockTypes.glassService },
    stockTypeIsTemplate() { return this.stock.type == InventoryStockTypes.template },
    stockTypeIsAssembly() { return this.stock.type == InventoryStockTypes.assembly },
    stockTypeIsGeneral() { return this.stock.type == InventoryStockTypes.general },

    stockUOMTypeOptions() {
      // Ignore certain UOM types not applicable to inventory
      var unavailableTypes = [UOMTypes.eachSubItem]
      return UOMTypeLookup.filter(lookup => !unavailableTypes.includes(lookup.value))
    },

    tabList() {
      var output = [{ title: 'General' }, { title: 'Details' }, { title: 'Pricing' }]
      if(this.stockTypeIsTemplate)
        output.push({ title: 'Template' })
      if(this.stockTypeIsAssembly)
        output.push({ title: 'Assembly' })
      return output
    },
  },
  methods: {
    handleSubmit() {
      
      this.submitting = true

      var stockData = _.cloneDeep(this.$data.stock)

      // Generate the data to send based on stock type
      if(this.stockTypeIsGlass) {
        stockData.glassSalesPriceList = this.$data.stockPriceGroupList        
      }
      else if(this.stockTypeIsGlassService) {
        stockData.serviceSalesPriceList = []
        
        // Format the prices into individual objects to match the stock sales price items
        this.$data.serviceSalesPriceList.forEach(servicePriceInfo => {
          if(_.isArray(servicePriceInfo.servicePriceRanges)) {
            servicePriceInfo.servicePriceRanges.forEach(rangePrice => {
              stockData.serviceSalesPriceList.push({
               stockPriceGroupId: rangePrice.stockPriceGroupId,
               servicePriceRangeId: rangePrice.servicePriceRangeId,
                isActive: rangePrice.isActive,
                price: rangePrice.price,
                minChargePrice: rangePrice.minChargePrice
              })
            })
          }
        })
      }
      else if(this.stockTypeIsGeneral) {
        stockData.generalSalesPriceList = this.$data.generalSalesPriceList
      }

      this.$data.stockForm = this.clearFormResponse()

      this.$apiService.inventoryService.createStock(stockData)
      .then(response => {
          this.submitting = false

          this.successToast('Stock Created')
          this.$router.push(`/inventory/stock/${response.data.id}`)
      })
      .catch(err => {
          // Process errors
          this.$data.stockForm = this.processFormResponse(err)
          this.$refs.stockWizard.displayErrors()

          this.submitting = false
      })
    },

    requestStockPriceGroupList() {
      this.$apiService.pricingService.getStockPriceGroupList().then(response => {
        this.$data.stockPriceGroupList = response.data.filter(priceGroup => priceGroup.isActive).map(priceGroup => {
          return {
            id: null,
            name: priceGroup.name,
            isActive: true,
            stockPriceGroupId: priceGroup.id,
            price: 0,
            minChargePrice: null,     // If null, inherit from price group
            minChargeQuantity: null,  // If null, inherit from price group
            minChargeInvoice: null,   // If null, inherit from price group
            stockPriceGroup: {
              minChargeQuantity: priceGroup.minChargeQuantity,
              minChargePrice: priceGroup.minChargePrice,
              minChargeInvoice: priceGroup.minChargeInvoice,
            }
          }
        })
      })
    },
    requestServicePriceGroupList() {
      this.$apiService.pricingService.getStockPriceGroupList().then(response => {
        this.$data.serviceSalesPriceList = response.data.filter(priceGroup => priceGroup.isActive && priceGroup.servicePriceRanges && priceGroup.servicePriceRanges.length > 0).map(priceGroup => {
          return {
            id: null,
            name: priceGroup.name,
            isActive: true,
           stockPriceGroupId: priceGroup.id,
            servicePriceRanges: priceGroup.servicePriceRanges.filter(serviceRange => serviceRange.isActive).map(serviceRange => {
              return {
                id: null,
               stockSalesPriceId: null,
               servicePriceRangeId: serviceRange.id,
               stockPriceGroupId: priceGroup.id,
                isPendingUpdate: false,
                isActive: true,
                name: serviceRange.name,
                minRange: serviceRange.minRange,
                maxRange: serviceRange.maxRange,
                price: 0,
                minChargePrice: 0,
              }
            })
          }
        })
      })
    }
  }
};
</script>
